import React, { Component } from 'react';
import {
  Container, Row, Col, Jumbotron, Card, CardBody, CardTitle, CardText, CardColumns, Badge, Alert,
} from 'reactstrap';
import { connect } from 'react-redux';
import backgroundImage from '../../Images/vet1.jpg';

class Landing extends Component {
  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <Container
          style={{
            height: '100%',
            // overflow: 'auto',
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: 'top',
            // backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Jumbotron
            fluid
            style={{ background: 'none' }}
          >
            <div className="pl-5">
              <h1 className="display-3">Vetcare Pet Clinic</h1>
              <h2 className="display-4">Dr. Amit H. Apte</h2>
              <h4>
                <Badge color="warning">drapte.vetcare@gmail.com</Badge>
                <Badge color="warning" className="ml-1">+91-20-25679175</Badge>
              </h4>
              <Alert color="primary" style={{ width: 'fit-content' }}>
                <p>
                  OPD hours: 10.00am to 12.00pm / 06.00pm to 08.00pm
                </p>
                <p>
                  Working Days:Monday to Saturday (Sunday closed)
                </p>
                <p>
                  Business Type:Service Provider
                </p>
              </Alert>
            </div>
          </Jumbotron>
          <Row>
            <CardColumns>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      Vaccinations
                    </h5>
                  </CardTitle>
                  <CardText>All types of Vaccinations for Dogs and Cats.</CardText>
                </CardBody>
              </Card>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      Surgeries
                    </h5>
                  </CardTitle>
                  <CardText>Surgical Treatment for Pets.</CardText>
                </CardBody>
              </Card>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      On call medical emergency
                    </h5>
                  </CardTitle>
                  <CardText>House Calls for MEDICAL EMERGENCIES only may be available.</CardText>
                </CardBody>
              </Card>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      Nutritional Advice
                    </h5>
                  </CardTitle>
                  <CardText>Customised Nutritional advice would be provided to respective pet.</CardText>
                </CardBody>
              </Card>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      Pet foods and accessories
                    </h5>
                  </CardTitle>
                  <CardText>Pet Foods and other Accessories are available.</CardText>
                </CardBody>
              </Card>
              <Card className="m-2" body style={{ backgroundColor: '#fdffc7', borderColor: '#333' }}>
                <CardBody>
                  <CardTitle>
                    <h5 className="d-flex flex-row justify-content-center">
                      Pet Grooming Facility By Appointment Only
                    </h5>
                  </CardTitle>
                </CardBody>
              </Card>
            </CardColumns>
          </Row>
          <Row className="pt-3">
            <Col sm="12">
              <h5 className="d-flex flex-row justify-content-center">
                Contact Us
              </h5>
              <div>
                Shop No. 7, Dr. Herekar Park Building,
                Near Kamala Nehru Park,
                Deccan Gymkhana,
                Pune – 411004
                Maharashtra, India.
              </div>
              <iframe
                title="vetcare"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d236.4530015992503!2d73.83457764059875!3d18.517690680543904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x23bfe2770b042551!2sVet%20Care%20Pet%20Clinic!5e0!3m2!1sen!2sin!4v1588844616101!5m2!1sen!2sin"
                width="100%"
                height="auto"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen
                aria-hidden="false"
              />
            </Col>
          </Row>
          <Row className="pt-3">
            <Col sm="12">
              <h5 className="d-flex flex-row justify-content-center">
                About Us
              </h5>
              <p>
                Dr Amit H Apte (B. V. Sc. & A.H.) is a Veterinary Doctor having 22 years of experience. Vet-Care Pet Clnic is owned by Dr. Amit Apte that assures gentle care & advanced medical treatment for your Pets. He provides all kinds of necessary service related to pets such as Vaccination, Health Checkup and Health Advices, Surgical Treatment and Medicines for Pets. Pet Foods & other useful accessories necessary for your pets are available.
              </p>
            </Col>
          </Row>
          <Row className="pt-3">
            <Col sm="12">
              <h6 className="d-flex flex-row justify-content-center">
                Developed by
                {' '}
                <a className="pl-1" href="https://silverfoxtechnologies.in">Silverfox Technologies</a>
              </h6>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  Auth: state.Auth,
  Application: state.Application,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
